import { calcPayoutFee, calcPayoutNet } from './constants';

export interface PendingPayoutSummary {
  count: number;
  currency: string;
  totalGrossCents: number;
  totalFeeCents: number;
  totalNetCents: number;
}

/**
 * Split payout rows into pending requests and paid payouts. Anything that is
 * not explicitly 'pending' counts as paid (legacy rows predate the status
 * column).
 */
export function splitPayoutsByStatus<T extends { status?: string | null }>(
  rows: T[],
): { pending: T[]; paid: T[] } {
  const pending: T[] = [];
  const paid: T[] = [];
  for (const row of rows) {
    (row.status === 'pending' ? pending : paid).push(row);
  }
  return { pending, paid };
}

/**
 * Totals for the admin fee summary cards, computed over the pending requests:
 * gross requested, fee retained (over the total), and net leaving the cashbox.
 */
export function summarizePendingPayouts(
  pending: Array<{ amount_cents: number; currency?: string | null }>,
): PendingPayoutSummary {
  const totalGrossCents = pending.reduce((sum, row) => sum + row.amount_cents, 0);
  return {
    count: pending.length,
    currency: pending[0]?.currency ?? 'BRL',
    totalGrossCents,
    totalFeeCents: calcPayoutFee(totalGrossCents),
    totalNetCents: calcPayoutNet(totalGrossCents),
  };
}
